/* tslint:disable:typedef-whitespace */
/*
tslint:disable:import-spacing no-inferrable-types
variable-name align no-trailing-whitespace component-class-suffix
no-string-literal component-selector
*/

import {ICommand}                from '@/util/i.command';
import {SearchWindow}            from '@/screens/ide/search.window';
import {Logger}                  from '@/util/logger';

/**
 *
 * @class SearchCommand
 *
 * @brief reversible navigation in the search browser
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      August 2020
 *
 */
export class SearchCommand implements ICommand {

  private newValue: string      = null;
  private oldValue: string      = null;
  private browser: SearchWindow = null;

  constructor(oldValue: string, newValue: string, browser: SearchWindow) {

    this.oldValue = oldValue;
    this.newValue = newValue;
    this.browser  = browser;
  }

  /** effect the command */
  execute() {

    Logger.debug('[search:ls] navigating: ', this.newValue);

    /* do the search */

    this.browser.go(this.newValue);
  }

  /** reverse the command's effects */
  unExecute() {

    /* undo the search */

    Logger.debug('[search:ls] going back to: ', this.oldValue);

    this.browser.go(this.oldValue);
  }

  /** return a string summary of this command */
  asString(): string {

    return '[serach:add] ' + this.oldValue + ' => ' + this.newValue;
  }

}
